import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, RouteProps, Redirect, useLocation } from 'react-router-dom';
import { Unauthorized } from '../../pages/ErrorPages/Unauthorized';

import { storeRedirectAfterLogin } from '../../../app/auth/auth.actions';
import { authSelectors } from '../../../app/auth/auth.selectors';

export const AdminOnlyRoute: FunctionComponent<RouteProps> = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const loggedUserId = useSelector(authSelectors.selectLoggedUser);
  const loggedUserisAdmin = useSelector(authSelectors.selectUserIsAdmin);
  const intendedUrl = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (!loggedUserId && intendedUrl !== '/') {
      dispatch(storeRedirectAfterLogin(intendedUrl));
    }
  }, [dispatch, intendedUrl, loggedUserId]);

  if (!loggedUserId) {
    return <Redirect to="/login" />;
  }

  if (!loggedUserisAdmin) {
    return <Route component={Unauthorized} />;
  }

  return <Route {...props} />;
};
